import {
    FETCH_WAIT_LIST_MESSAGES,
    DESTROY_WAIT_LIST_MESSAGE,
    APPEND_WAIT_LIST_MESSAGE,
    SET_ORGANIZATION_CURRENT
  } from '../constants/actionTypes'
  
  export default (state = '', action) => {
        switch (action.type) {
            case APPEND_WAIT_LIST_MESSAGE:
                return [
                    action.payload,
                    ...state
                ]
            case FETCH_WAIT_LIST_MESSAGES:
                return [
                    ...action.payload
                ]
            case DESTROY_WAIT_LIST_MESSAGE:
                return state.filter((s)=>s.id != action.payload)
            case SET_ORGANIZATION_CURRENT:
                return ''
            default:
                return state
        }
  }
  


// WEBPACK FOOTER //
// ./src/reducers/waitListMessages.js